module.exports = __webpack_public_path__ + "img/bg-dark.b9c5aac1.png";